import React from "react";
import styles from "../stylesERv2.module.scss";

/**
 * Detalle de las facturas que componen una celda (cuenta × mes) del ER v2.
 *
 * La lista NO se consulta aparte: llega desde `costosER.detalleDe(cuenta, mes)`, que
 * devuelve las MISMAS facturas que el motor sumó para esa celda, con el MISMO importe
 * (neto o exento, sin IVA, sin CAPEX, notas de crédito en negativo, >= 2026-01-01).
 * Por eso el total del modal es igual al valor de la celda por construcción.
 *
 * El markup sigue el molde de los modales del ER (overlay + modalContent + modalTable),
 * para que se vea igual que los demás.
 */
export const DetalleFacturasModal = ({ isOpen, titulo, mes, facturas = [], formatCurrency, onClose }) => {
  if (!isOpen) return null;

  const total = facturas.reduce((sum, f) => sum + (f.importe || 0), 0);

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <h3>
          {titulo} — {mes}
        </h3>

        {facturas.length === 0 ? (
          <p style={{ margin: "16px 0", color: "#666", fontSize: "0.9rem" }}>
            No hay facturas que compongan esta celda.
          </p>
        ) : (
          <table className={styles.modalTable}>
            <thead>
              <tr>
                <th style={{ textAlign: "left" }}>Proveedor</th>
                <th style={{ textAlign: "center" }}>Fecha</th>
                <th style={{ textAlign: "center" }}>N° de factura</th>
                <th style={{ textAlign: "end" }}>Importe</th>
              </tr>
            </thead>
            <tbody>
              {facturas.map((f, i) => (
                <tr key={`${f.origen}-${f.numero}-${i}`}>
                  <td style={{ textAlign: "left" }}>{f.proveedor}</td>
                  <td style={{ textAlign: "center" }}>{f.fecha}</td>
                  <td style={{ textAlign: "center" }}>
                    {f.numero}
                    {f.esNotaCredito && (
                      <span
                        title="Nota de crédito: resta del total"
                        style={{
                          marginLeft: 6,
                          padding: "1px 6px",
                          borderRadius: 10,
                          background: "#fdecea",
                          color: "#c62828",
                          fontSize: "0.7rem",
                          fontWeight: 700,
                          verticalAlign: "middle",
                        }}
                      >
                        NC
                      </span>
                    )}
                  </td>
                  <td style={{ textAlign: "end" }}>{formatCurrency(f.importe)}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={3} style={{ textAlign: "end", fontWeight: 600 }}>
                  Total
                </td>
                <td style={{ textAlign: "end", fontWeight: 600 }}>{formatCurrency(total)}</td>
              </tr>
            </tfoot>
          </table>
        )}

        <div className={styles.modalActions}>
          <button className={styles.btnClose} onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};
